module.exports = __webpack_public_path__ + "img/saddle.0c32ba86.png";